import { render } from "./Add.vue?vue&type=template&id=7bc39dc6"
import script from "./Add.vue?vue&type=script&lang=js"
export * from "./Add.vue?vue&type=script&lang=js"
script.render = render

export default script